import { useEffect, useState } from 'react';
import {
	Input,
	Form,
	Button,
	Flex,
	FlexItem,
	Select,
} from '@bigcommerce/big-design';
import { useClient } from '../../../../../context/client';
import { useCustomerGroup } from '../../../context';
import './CustomProduct.css';

export default function CustomProduct({ onAddCustomProduct }) {
	const [customerGroup] = useCustomerGroup();
	const [description, setDescription] = useState('');
	const [color, setColor] = useState('');
	const [partNumber, setPartNumber] = useState('');
	const [year, setYear] = useState('');
	const [make, setMake] = useState('');
	const [model, setModel] = useState('');
	const [seatDescription, setSeatDescription] = useState('');
	const [row, setRow] = useState('');
	const [vendorName, setVendorName] = useState('');
	const [price_inc_tax, setPriceIncTax] = useState('');
	const [price_exc_tax, setPriceExcTax] = useState('');
	const [vendors, setVendors] = useState([]);
	const client = useClient();

	useEffect(() => {
		client
			.getVendors()
			.then((vendorsList) => {
				let _vendors = [];
				vendorsList.forEach((vendor) => {
					_vendors.push({
						value: vendor,
						content: vendor,
					});
				});
				setVendors(_vendors);
				return false;
			})
			.catch((e) => e);
	}, []);

	const onFormSubmit = (event) => {
		event.preventDefault();
		onAddCustomProduct(
			description,
			color,
			partNumber,
			year,
			make,
			model,
			seatDescription,
			row,
			vendorName,
			price_inc_tax,
			price_exc_tax,
		);
	};

	return (
		<Form onSubmit={onFormSubmit}>
			<Flex flexWrap="wrap" justifyContent="flex-start" alignItems="center">
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="150px"
					flexGrow={0}
					flexShrink={1}
				>
					<Input
						placeholder="Product"
						type="text"
						required
						value={description}
						onChange={(e) => setDescription(e.target.value)}
						disabled={!customerGroup}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="150px"
					flexGrow={0}
					flexShrink={1}
				>
					<Input
						placeholder="Color"
						type="text"
						required
						value={color}
						onChange={(e) => setColor(e.target.value)}
						disabled={!customerGroup}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="100px"
					flexGrow={0}
					flexShrink={1}
				>
					<Input
						placeholder="Part Number"
						type="text"
						required
						value={partNumber}
						onChange={(e) => setPartNumber(e.target.value)}
						disabled={!customerGroup}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="80px"
					flexGrow={0}
					flexShrink={1}
				>
					<Input
						placeholder="Year"
						type="text"
						required
						value={year}
						onChange={(e) => setYear(e.target.value)}
						disabled={!customerGroup}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="150px"
					flexGrow={0}
					flexShrink={1}
				>
					<Input
						placeholder="Make"
						type="text"
						required
						value={make}
						onChange={(e) => setMake(e.target.value)}
						disabled={!customerGroup}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="150px"
					flexGrow={0}
					flexShrink={1}
				>
					<Input
						placeholder="Model"
						type="text"
						required
						value={model}
						onChange={(e) => setModel(e.target.value)}
						disabled={!customerGroup}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="100px"
					flexGrow={0}
					flexShrink={1}
				>
					<Input
						placeholder="Row"
						type="text"
						required
						value={row}
						onChange={(e) => setRow(e.target.value)}
						disabled={!customerGroup}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="500px"
					flexGrow={0}
					flexShrink={1}
				>
					<Input
						placeholder="Seat Description"
						type="text"
						required
						value={seatDescription}
						onChange={(e) => setSeatDescription(e.target.value)}
						disabled={!customerGroup}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="150px"
					flexGrow={0}
					flexShrink={1}
				>
					<Select
						placeholder="Vendor"
						required
						value={vendorName}
						onOptionChange={(e) => setVendorName(e)}
						disabled={!customerGroup}
						options={vendors}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="80px"
					flexGrow={0}
					flexShrink={1}
				>
					<Input
						placeholder="Price Exc Tax"
						type="number"
						required
						value={price_exc_tax}
						onChange={(e) => setPriceExcTax(e.target.value)}
						disabled={!customerGroup}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="auto"
					marginRight="xSmall"
					marginBottom="small"
					flexBasis="80px"
					flexGrow={0}
					flexShrink={1}
				>
					<Input
						placeholder="Price Inc Tax"
						type="number"
						required
						value={price_inc_tax}
						onChange={(e) => setPriceIncTax(e.target.value)}
						disabled={!customerGroup}
					/>
				</FlexItem>
				<FlexItem
					alignSelf="center"
					marginBottom="small"
					flexBasis="auto"
					flexGrow={0}
					flexShrink={0}
				>
				<Button variant="secondary" disabled={!customerGroup}>
					Add Custom Item
				</Button>
				</FlexItem>
			</Flex>
		</Form>
	);
}
